import React, { PureComponent } from 'react';
import { Row, Col, Button } from 'react-bootstrap';
import axios from 'axios';
import InputComponent from '../../components/baseComponents/input';
import appConstant from '../../../constants/app';

class NewSectionForm extends PureComponent {
  state = {
    label: '',
  }

  refFields = {};
  
  handleInputChange = (val, name) => {
    this.setState({[name]: val});
  }

  isValidForm = () =>
    Object.keys(this.refFields)
      .map(field => this.refFields[field] && this.refFields[field].validate())
      .reduce((sum, validField) => validField != null && sum + (!validField ? 1 : 0), 0) === 0;

  onFormSubmit = (e) => {
    const token = localStorage.getItem('token');
    const {
      label,
    } = this.state;

    e.preventDefault() // Stop form submit

    if(!this.isValidForm()) return false;

    axios({
      method: 'post',
      url: `${appConstant.API_URL}/section/create?access_token=${token}`,
      headers: {
        'Content-Type': 'application/json'
      },
      data: {
        label: label,
      },
    })
    .then(res => {
      this.props.onClose();
      this.props.onAccept();
    }).catch(err => {
      console.log(err);
    });
  };

  render() {
    const {
      label,
    } = this.state;

    return (
      <div>
        <form onSubmit={this.onFormSubmit}>
          <Row className="link-form-row">
            <Col sm={12}>
              <label>Label</label>
              <InputComponent
                value={label}
                ref={(input) => { this.refFields.label = input; }}
                inputGroup="label"
                validationRules="required"
                customErrorMessage="Required field"
                placeholder='Label'
                classes='form-control'
                onChange={this.handleInputChange}
              />
            </Col>
          </Row>
          <Row className="confirmation-btns-footer link-form-row">
            <Col sm={12}>
              <Button
                className="cancel-btn"
                onClick={this.props.onClose}
              >
                Cancel
              </Button>
              <Button
                type="submit"
                className="accept-btn"
              >
                Add
              </Button>
            </Col>
          </Row>
        </form>
      </div>
    );
  }
}

export default NewSectionForm;


// WEBPACK FOOTER //
// ./src/app/screens/sections/newSectionForm.js